import { takeLatest, put, call } from "redux-saga/effects";
import { handleApiError, isNotFoundError } from "@utils/errorHandler";

import {
  loadAllCenter,
  loadSingleCenter,
  setSingleCenterNotFound,
} from "./CenterList.slice";

import { loadAllCenterAPI, loadSingleCenterAPI } from "./CenterList.api";

export const LOAD_ALL_CENTER = {
  LOADING: "Load all center  loading",
  SUCCESS: "Load all center  success",
  ERROR: "Load all center  error",
};

export const LOAD_SINGLE_CENTER = {
  LOADING: "Load single center  loading",
  SUCCESS: "Load single center  success",
  ERROR: "Load single center  error",
};

function* loadAllCenterWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadAllCenterAPI, payload);
    yield put(loadAllCenter(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_ALL_CENTER.ERROR, error });
  }
}

function* loadSingleCenterSagaWorker(action) {
  yield put(setSingleCenterNotFound(false));
  const { payload } = action;

  try {
    const data = yield call(loadSingleCenterAPI, payload);
    yield put(loadSingleCenter(data));
  } catch (error) {
    if (isNotFoundError(error)) {
      yield put(setSingleCenterNotFound(true));
      return;
    }
    handleApiError(error);
    yield put({ type: LOAD_SINGLE_CENTER.ERROR, error });
  }
}

export function* loadAllCenterSaga() {
  yield takeLatest(LOAD_ALL_CENTER.LOADING, loadAllCenterWorker);
}

export function* loadSingleCenterSaga() {
  yield takeLatest(LOAD_SINGLE_CENTER.LOADING, loadSingleCenterSagaWorker);
}
